import createRemoteSettingHook from '@/utils/user/createRemoteSettingHook';

const REMOTE_SETTING_NAME = 'gen_ai_text_input_title';

const DEFAULT_TEXT_INPUT_TITLE = 'Enter text';

const isTextInputTitle = (settings: unknown): boolean =>
  typeof settings === 'string' && settings.length > 0;

const { useSetting } = createRemoteSettingHook({
  name: REMOTE_SETTING_NAME,
  defaultValue: DEFAULT_TEXT_INPUT_TITLE,
  validate: isTextInputTitle,
  select: (title) => title,
});

/**
 * Remotely-configurable label for the Create screen's text inputs. A bare string
 * setting rather than an object, so the empty-string guard in `validate` is what
 * stops a blank remote value from wiping the label. Defaults to "Enter text";
 * fetched once per session.
 */
const useTextInputTitle = useSetting;

export default useTextInputTitle;
